<template>
    <div id="toolbar">
        <button @click="$store.dispatch('loadCatalog','/data/jrecords.json');">load data</button>
        <button @click="loadTabulator()">load data 2</button>
        
        <select v-model="$store.state.selected" v-on:change="$store.dispatch('loadCatalog','/data/jrecords.json');">
            <option disabled value="0">Выберите базу данных</option>
            <option value="value1">ФСНТО2008</option>
            <option value="value2">ФСНТО2008-2</option>
        </select><span>Выбрано: {{selected}}</span>
    <div><input type="number" v-model.number="$store.state.mynumber" />{{$store.state.mynumber}}</div>
        
        <tabulator title="справочник"/>
        <editor title="редактор" />
    </div>
</template>


<script>
import Vue from 'vue';
import tabulator from './tabulator';
import editor from './editor';

//import dialog from '@/dialogs/dialog';

export default {   
    name:'toolbar',
    components:{tabulator, editor},
    template: '<toolbar/>',    
    data () {
        return {
            msg: 'Welcome to xlsgenvue',
            selected: '',
            mynumber: 100
        }
    },
    
    methods:{
        loadTabulator(){
            console.log(tabulator);
            console.log(this.$store.state.tableData);
            //tabulator.data.tableData = this.$store.state.tableData;
            //tabulator.data.tabulator.replaceData(this.$store.state.tableData);  
        }
    }
}
</script>

